import { MediaViewerFileType } from '@arrived/models';

export const getDerivedFileType = (fileName: string): MediaViewerFileType => {
  if (fileName.endsWith('.pdf')) {
    return MediaViewerFileType.PDF;
  }

  return MediaViewerFileType.IMAGE;
};
